

















import type { Comment } from '@getaccept/lib-shared/src/contextual-comments/types/comment';
import type { PropType, Ref } from '@vue/composition-api';
import { nextTick, defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import debounce from 'debounce';
import { CommentStatus } from '../types/comment-status';
import type { UpdateCommentDto } from '../types/update-comment-dto';

export default defineComponent({
  name: 'CommentCard',
  props: {
    comment: {
      type: Object as PropType<Comment>,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const commentInput: Ref<HTMLInputElement> = ref(null);

    const commentCard = ref(null);

    const setFocus = () => {
      if (props.selected) {
        (commentInput.value as HTMLInputElement).focus();
      }
    };

    watch(() => props.selected, setFocus);

    onMounted(async () => {
      setFocus();
      await nextTick();
      emit('height', { commentId: props.comment.id, height: commentCard.value.$el.offsetHeight });
    });

    const emitText = (text: string) => {
      const payload: Partial<UpdateCommentDto> = { text };
      emit('update', payload);
    };

    const emitTextDebounce = debounce(emitText, 300);

    const handleBlur = (value: string) => {
      if (value === props.comment.text) {
        return;
      }
      emitTextDebounce.clear();
      emitText(value);
    };

    return { commentInput, emitTextDebounce, commentCard, handleBlur, CommentStatus };
  },
});
